import { ArenaOpsUsdtSchema } from "./arena-ops-filters.dto";
import { z } from "zod";

/**
 * T3 — partner / KOL link attribution. `isCapped` exists so a link whose
 * `maxClaims` throttles it is visible without an operator doing arithmetic.
 */
export const ArenaOpsTicketLinkRowSchema = z.object({
  linkId: z.string(),
  slug: z.string(),
  partnerName: z.string(),
  maxClaims: z.number().int(),
  claims: z.number().int(),
  ticketsGranted: z.number().int(),
  ticketsUsed: z.number().int(),
  faceIssuedUsdt: ArenaOpsUsdtSchema,
  faceRedeemedUsdt: ArenaOpsUsdtSchema,
  isCapped: z.boolean(),
});

/**
 * `"lifetime"` — this endpoint takes no `from`/`to` and the rows cover each
 * link's whole history. Link performance is a stock, not a flow.
 *
 * It is in the contract rather than a comment because the panel MUST render a
 * visible marker saying it does not follow the filter bar. A panel that quietly
 * ignores the date range is a lie; one that says it ignores it is a design —
 * and without the marker a "link never claimed" reading looks scoped to whatever
 * range the operator happens to have selected.
 *
 * A single-member union today, so a second scope can be added without the panel
 * having to guess what the absence of the field meant.
 */
export const ArenaOpsPanelScopeSchema = z.literal("lifetime");
export type ArenaOpsPanelScope = z.infer<typeof ArenaOpsPanelScopeSchema>;

export type ArenaOpsTicketLinkRow = z.infer<typeof ArenaOpsTicketLinkRowSchema>;

export const ArenaOpsTicketLinksResponseSchema = z.object({
  scope: ArenaOpsPanelScopeSchema,
  rows: z.array(ArenaOpsTicketLinkRowSchema),
  nextCursor: z.string().nullable(),
});
export type ArenaOpsTicketLinksResponse = z.infer<typeof ArenaOpsTicketLinksResponseSchema>;
